import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  const { privacy } = t;

  return (
    <div className="privacy-policy">
      <Link to="/" className="back-link">
        {privacy.backLink}
      </Link>
      <h1>{privacy.title}</h1>
      <p>
        <strong>{privacy.effectiveDateLabel}</strong> {privacy.effectiveDate}
      </p>

      {privacy.sections.map((section) => (
        <React.Fragment key={section.title}>
          <h2>{section.title}</h2>
          <p>{section.body}</p>
        </React.Fragment>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
